export default __webpack_public_path__ + "static/media/instagram_2.656db3ad.png";